/* import __COLOCATED_TEMPLATE__ from './project-details-files.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { PROJECT_DETAILS__PROGRESSIVE_INCLUDES } from "sh-www/constants/routes/project-details";

const CLASS_NAME = 'SH-c-project-details-files';

class ProjectDetailsFiles extends Component {
  @service('state-managers/application') applicationStateManager;
  @service('commands/application-commands') applicationCommandService;
  @service('error-tracker') errorTracker;

  get className() {
    return CLASS_NAME;
  }

  @task
  *removeAssetItem(asset) {
    try {
      yield this.applicationCommandService.removeAsset(asset.application, asset);
      yield this.args.loadApplicationTask.perform(asset.application.id, PROJECT_DETAILS__PROGRESSIVE_INCLUDES.FILES);
      this.applicationStateManager.addToast('Asset removed');
    } catch (e) {
      this.applicationStateManager.addToast('There was a problem removing asset. Please try again.');
      this.errorTracker.error(e, this, `removeAssetItem task failed for application ${asset.application.id} and asset ${asset.id}.`);
    }
  }
}

export default ProjectDetailsFiles;
